import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=b41ad276&scoped=true&"
import script from "./Buy.vue?vue&type=script&lang=ts&"
export * from "./Buy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41ad276",
  null
  
)

export default component.exports